import React, { useState } from "react";
import { MenuItem, Button } from "@mui/material";
import styles from "./Style.module.css";
import CustomDatePicker from "../../../../components/FormFields/DatePicker/CustomDatePicker";
import useDoctorTopFieldHook from "./DoctorTopField.hook";
import CustomSelectField from "../../../../components/FormFields/SelectField/SelectField.component";
import MultiSelectField from "../../../../components/FormFields/SelectField/MultipleSelect.component";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useSelector } from "react-redux";

const DoctorTopField = ({ form, changeTextData, handleReset }) => {
  const {
    user: { clients },
  } = useSelector((state) => state.auth);
  const { listData } = useDoctorTopFieldHook({ form });

  
  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.filterContainer}>
        <div className={styles.formGroup}>
          <div className={styles.headingWrap}>Start Date</div>
          <CustomDatePicker
            clearable
            // label={"Start Date"}
            // maxDate={new Date()}
            onChange={(date) => {
              changeTextData(date, "start_date");
            }}
            value={form?.start_date}
            className={styles.date}
            borderRadius={{
              topLeft: 0,
              topRight: 0,
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <div className={styles.headingWrap}>End Date</div>
          <CustomDatePicker
            clearable
            // label={"End Date"}
            maxDate={new Date()}
            onChange={(date) => {
              changeTextData(date, "end_date");
            }}
            value={form?.end_date}
            className={styles.date}
            borderRadius={{
              topLeft: 0,
              topRight: 0,
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <div className={styles.headingWrap}>Client</div>

          <CustomSelectField
            // label={"Client"}
            disabled
            value={form?.client_id}
            handleChange={(value) => {
              changeTextData(value, "client_id");
            }}
            borderRadius="0px 0px 8px 8px"
          >
            {clients?.map((val, index) => (
              <MenuItem key={`clients_${index}`} value={val?.id}>
                {val?.name}
              </MenuItem>
            ))}
          </CustomSelectField>
        </div>

        <div className={styles.formGroup}>
          <div className={styles.headingWrap}>Program</div>

          <MultiSelectField
            // label="Program"
            name="program_ids"
            value={form?.program_ids}
            options={listData?.PROGRAMS || []}
            getOptionLabel={(opt) => opt?.label}
            getOptionValue={(opt) => opt?.id}
            handleChange={(value) => {
              changeTextData(value, "program_ids");
            }}
            borderRadius="0px 0px 8px 8px"
          />
        </div>
        <div className={styles.formGroup}>
          <div className={styles.headingWrap}>Doctor</div>
          <MultiSelectField
            // label="State"
            name="doctor_ids"
            value={form?.doctor_ids}
            options={listData?.PROGRAM_DOCTORS || []}
            getOptionLabel={(opt) => opt?.name}
            getOptionValue={(opt) => opt?.id}
            handleChange={(value) => {
              changeTextData(value, "doctor_ids", listData?.PROGRAM_DOCTORS);
            }}
            borderRadius="0px 0px 8px 8px"
          />
        </div>
        <div className={styles.formGroup}></div>
        <Button className={styles.resetButton} onClick={handleReset}>
          <div className={styles.iconWrap}>
            <RefreshIcon styles={{ FontSize: ".75rem", color: "red" }} />
            RESET ALL
          </div>
        </Button>
      </div>
      {/* <div className={styles.statsContainer}>
        <div className={styles.statCard}>
          <strong>Total Patients</strong> <br /> 32,846
        </div>
        <div className={styles.statCard}>
          <strong>Active Patients</strong> <br /> 28,946
        </div>
        <div className={styles.statCard}>
          <strong>Adherence</strong> <br /> 92.13%
        </div>
        <div className={styles.statCard}>
          <strong>Associated Doctors</strong> <br /> 120
        </div>
      </div> */}
    </div>
  );
};

export default DoctorTopField;
